export const texts_ca = {
    button: {
        back_to_list: 'Tornar a la llista',
        close: 'Tancar',
        change_password_now: 'Canviar contrasenya ara',
        delete_patient: 'Esborrar pacient',
        delete_user: 'Esborrar usuari',
        donwload_report: 'Descarregar informe en PDF',
        edit: 'Editar',
        edit_this_patient: 'Editar aquest pacient',
        edit_this_user: 'Editar aquest usuari',
        list_view: 'Llista',
        hide_filters: 'Amagar filtres',
        no_cancel: 'No, cancel·lar',
        no_take_me_back: 'No, tornar enrere',
        report: 'Informe',
        reset_filters: 'Restablir filtres',
        reset_password: 'Restablir contrasenya',
        save_changes: 'Guardar canvis',
        show_filters: 'Mostrar filtres',
        show_report: 'Mostrar informe',
        table_view: 'Taula',
        yes_delete: 'Sí, esborrar',
        yes_reset_password: 'Sí, restablir contrasenya',
        yes_save_changes: 'Sí, guardar canvis',
    },
    nav: {
        change_password: 'Canviar contrasenya',
        home: 'Inici',
        legal: 'Informació legal',
        patient: {
            list: 'Veure tots els pacients',
            add: 'Afegir nou pacient',
        },
        user: {
            list: 'Veure tots els usuaris',
            add: 'Afegir nou usuari',
        },
    },
    login: {
        username: 'Usuari',
        password: 'Contrasenya',
        sign_in: 'Connectar',
        sign_out: 'Desconnectar',
        incorrect: 'Usuari o contrasenya incorrectes. Si us plau, torna a provar-ho.',
    },
    password: {
        current: 'Contrasenya actual',
        has_to_reset_password: 'Vol restablir la seva contrasenya?',
        new1: 'Nova contrasenya',
        new2: 'Nova contrasenya (confirmació)',
        update: 'Actualitzar contrasenya',
        reset_label: 'Restablir contrasenya',
        reset_input: 'Introduïu el vostre correu electrònic o nom d’usuari',
        reset_placeholder: 'Correu electrònic o nom d’usuari',
        rule_no_empty:
            'Si us plau, ompli els tres camps. El primer amb la seva contrasenya actual i els dos següents amb la nova contrasenya que desitja.',
        rule_no_confirmation:
            'La contrasenya nova i la contrasenya de confirmació no coincideixen.',
        rule_too_short: 'La nova contrasenya ha de tenir com a mínim 10 caràcters.',
        rule_no_upper: 'La nova contrasenya ha de tenir com a mínim una lletra en majúscula.',
        rule_no_lower: 'La nova contrasenya ha de tenir com a mínim una lletra en minúscula.',
        rule_no_number: 'La nova contrasenya ha de tenir com a mínim un número.',
        rule_no_special: 'La nova contrasenya ha de tenir com a mínim un caràcter especial.',
    },
    label: {
        accuracy: 'Precisió',
        action_required: 'Acció necessària',
        add_later: 'Afegir més tard',
        administrator: 'Administrador',
        age: 'Edat',
        amyloid_pet: 'PET Amiloide',
        apoe_genotype: 'Genotip ApoE',
        between_0_6: 'Entre 0 i 6',
        between_0_10: 'Entre 0 i 10',
        between_7_12: 'Entre 7 i 12',
        between_11_20: 'Entre 11 i 20',
        between_13_18: 'Entre 13 i 18',
        between_21_30: 'Entre 21 i 30',
        between_55_60: 'Entre 55 i 60',
        between_61_70: 'Entre 61 i 70',
        between_71_80: 'Entre 71 i 80',
        between_81_85: 'Entre 81 i 85',
        cancel: 'Cancel·lar',
        cdr_must_be_05: 'CDR ha de ser 0.5',
        cdr_values: '0 = No demència / 0.5 = Qüestionable / 1 = Lleu / 2 = Moderada / 3 = Greu',
        ci: 'IC',
        client: 'Client',
        code: 'Codi',
        confirm: 'Confirmar',
        completed: 'Completat',
        conclusion: 'Conclusió',
        created: 'Creat',
        download_template: 'Descarregar plantilla',
        e4_carrier_non: 'Portador E4 / No portador E4',
        edit_patient: 'Editar pacient',
        edit_user: 'Editar usuari',
        email: 'Email',
        female: 'Dona',
        first_name: 'Nom',
        full_name: 'Nom complet',
        header_ctrl: 'CN %',
        header_mci: 'DCL Estable %',
        header_ad: 'DCL Progressat %',
        import_patients: 'Importar pacients',
        interpretation: 'Interpretació',
        last_name: 'Cognoms',
        male: 'Home',
        male_female: 'Home / Dona',
        maintenance:
            'MAP-AD Test està en manteniment en aquests moments. Si us plau, torna a provar-ho més tard.',
        mass_upload: 'Carrega massiva',
        medical_association: 'Associació mèdica',
        medical_position: 'Càrrec',
        methylcytosines:
            "L'ADN del pacient s'ha utilitzat al procés de laboratori MAP-AD Test Oligos, seguint el manual d'usuari. Les citosines mitocondrials metilades han sigut mesurades fent servir el MiSeq® System (Illumina) i analitzades pel MAP-AD Test Software per obtenir els resultats.",
        methodology: 'Metodologia',
        must_be_0_18: 'Ha de ser un número entre 0 i 18',
        must_be_0_30: 'Ha de ser un número entre 0 i 30',
        must_be_1_100000: 'Ha de ser un número entre 1 i 100000',
        must_be_55_85: 'Ha de ser un número entre 55 i 85',
        na: 'N/D',
        neurological_conclusion: 'Conclusió neurològica',
        neurologist: 'Neuròleg',
        new_patient: 'Nou pacient',
        new_user: 'Nou usuari',
        negative: 'Negatiu',
        not_available: 'No disponible',
        not_found: 'Pàgina no trobada (error 404)',
        not_reported: 'No informat',
        password_change: 'Canvi de contrasenya',
        password_required_sign_report: "Contrasenya (necessària per a signar l'informe)",
        patient: 'Pacient',
        patients: 'Pacients',
        pending: 'Pendent',
        pet: 'PET Amiloide',
        positive: 'Positiu',
        pos_neg: 'Positiu / Negatiu',
        prob_ad: 'Probabilitat de MA',
        prob_ctrl: 'Probabilitat de Control',
        prob_mci: 'Probabilitat de DCL',
        prob_non_progressed: 'Probabilitat de No Progressió',
        prob_progressed: 'Probabilitat de Progressió',
        purchased_requests: 'Sol·licituds comprades',
        registration_number: 'Número de col·legiat',
        report_available: 'Informe disponible',
        req_email: 'Adreça de correu electrònic vàlida necessària',
        req_info: 'Informació necessària',
        req_info_2_15_chars: 'Informació necessària (de 2 a 15 caràcters)',
        req_info_2_25_chars: 'Informació necessària (de 2 a 25 caràcters)',
        req_info_5_25_chars: 'Informació necessària (de 5 a 25 caràcters)',
        req_info_7_chars: 'Informació necessària (exactament 7 caràcters, format AB12345)',
        result: 'Resultat',
        role: 'Rol',
        search: 'Cercar',
        select_conclusion: 'Selecciona una conclusió',
        sex: 'Sexe',
        signature: 'Signatura',
        user_code: 'Codi d’usuari',
        unknown_role: 'Rol desconegut',
        username: 'Usuari',
        username_required_sign_report: "Usuari (necessari per a signar l'informe)",
        users: 'Usuaris',
        waiting_sample: "A l'espera de mostra",
    },
    feedback: {
        cdr_must_be_05:
            "Per tal de predir la probabilitat de progressió d'un pacient cal que el seu CDR sigui 0.5.",
        confirm_action: 'Si us plau, confirma aquesta acció',
        confirm_correct: 'Confirmes que és correcte?',
        delete_patient: 'Esborrar pacient {{code}} amb les següents característiques: {{info}}',
        delete_user: 'Esborrar usuari {{user}}',
        email_sent_user:
            "S'ha enviat un correu electrònic a l'adreça de correu electrònic de l'usuari amb aquesta informació. No necessites fer res més al respecte.",
        enter_conclusion: 'Si us plau, introdueix la teva conclusió neurològica.',
        no_patients_meeting_criteria: 'No hi ha pacients que compleixin aquests criteris.',
        no_users_meeting_criteria: 'No hi ha usuaris que compleixin aquests criteris.',
        not_logged_in:
            'No has iniciat sessió o la teva sessió ha caducat. Si us plau, inicia sessió per continuar.',
        password_change_required:
            "Has de canviar la contrasenya temporal que ADmit Therapeutics t'ha proporcionat abans d'accedir a aquesta informació.",
        password_changed:
            "La teva contrsenya s'ha actualitzat. Si us plau, torna't a connectar fent servir la nova contrasenya.",
        password_not_changed:
            "La contrasenya no s'ha pogut actualitzar. Si us plau, verifica que la contrasenya és correcta i torna a provar-ho. Contacta amb ADmit Therapeutics si necessites ajuda.",
        password_not_reset:
            "La contrasenya no s'ha pogut restablir. Si us plau, torna a provar-ho més tard o contacta amb ADmit Therapeutics si necessites ajuda.",
        patient_deleted: "El pacient {{patient}} s'ha esborrat amb èxit.",
        patient_not_deleted:
            "No s'ha pogut esborrar el pacient. Si us plau, torna a provar-ho més tard o contacta amb ADmit Therapeutics si necessites ajuda.",
        patient_not_saved:
            "No s'ha pogut guardar el pacient. Si us plau, comprova que tots els camps es troben omplerts i torna a provar-ho. Si el problema persisteix, contacta amb ADmit Therapeutics per rebre ajuda.",
        patient_saved: 'Nou pacient creat amb el següent codi i aquestes característiques:',
        pdf_report_not_delivered:
            "No s'ha pogut descarregar l'informe en format PDF. Si us plau, torna a provar-ho més tard.",
        please_wait_request_processed:
            "Si us plau, espera mentre la teva petició s'està processant...",
        purchased_requests_exhausted:
            'No és possible crear aquest pacient perquè no et queden sol·licituds. Si us plau, contacta amb ADmit Therapeutics.',
        purchased_requests_info:
            '{{purchased}} sol·licituds comprades – {{created}} pacients creats – {{left}} sol·licituds restants',
        remember_code_patient:
            'Recorda que pots consultar el codi de cada pacient al seu registre.',
        reset_password: "Restablir contrasenya per l'usuari {{user}}",
        select_option: 'Si us plau, procedeix a seleccionar la opció desitjada del menú.',
        session_expired:
            "La teva sessió ha caducat. Si us plau, torna't a connectar o contacta amb ADmit Therapeutics si has oblidat la teva contrasenya.",
        sign_report_auth_failed:
            'Autenticació fallida. Si us plau, introdueix un usuari i contrasenya correctes per a signar aquest informe.',
        signature_file_required:
            'Per al rol de neuròleg escollit es necessita un arxiu que contigui la firma.',
        signature_not_uploaded:
            "L'arxiu que conté la signatura no s'ha pogut guardar al servidor. Si us plau, torna a provar-ho més tard o contacta amb ADmit Therapeutics si necessites ajuda.",
        user_deleted: "L'usuari {{user}} s'ha esborrat amb èxit.",
        user_not_deleted:
            "No s'ha pogut esborrar l'usuari. Si us plau, torna a provar-ho més tard o contacta amb ADmit Therapeutics si necessites ajuda.",
        user_not_saved:
            "No s'ha pogut guardar l'usuari. Si us plau, comprova que tots els camps es troben omplerts i torna a provar-ho. Si el problema persisteix, contacta amb ADmit Therapeutics per rebre ajuda.",
        user_not_saved_duplicated:
            "No s'ha pogut guardar l'usuari. Si us plau, comprova que no existeix un altre usuari amb el mateix nom d'usuari o adreça de correu electrònic.",
        user_saved:
            'Usuari <strong>{{user}}</strong> creat/actualitzat amb una contrasenya temporal secreta.',
        welcome: 'Benvingut MAP-AD Test.',
        will_get_email_results:
            'Rebràs un correu electrònic quan el resultat del pacient es trobi disponible.',
    },
    legal: {
        title: 'Informació legal',
        udi: '08437026887124',
        company: 'ADmit Therapeutics',
        focused:
            "Enfocat en la comercialització d'una tecnologia novell per a la detecció primerenca de la Malaltia d'Alzheimer",
        description:
            "El MAP-AD® Test Software és un component del dispositiu mèdic de diagnòstic in vitro (IVD) MAP-AD® Test. MAP-AD és un software dispositiu mèdic de diagnòstic in vitro que té com a ús previst el pronòstic de la Demència per Malaltia d'Alzheimer en pacients amb deteriorament cognitiu lleu de 55 a 85 anys, mitjançant la mesura de metilcitosines en l'ADN total extret de sang humana total i una classificació qualitativa automàtica dels subjectes com a progressats o no progressats a demència per la Malaltia d’Alzheimer. El MAP-AD® Test Software està destinat a ser utilitzat per personal sanitari professional.",
        version: 'Versió del software',
        serial: 'Número de sèrie',
        cookies:
            "Aquest lloc web fa servir les seves propies cookies i cookies de tercers per recolectar informació amb l'objectiu de millorar els nostres serveis. El seu ús continuat constitueix l'acceptació de l'instalació d'aquestes cookies. L'usuari té l'opció de configurar el navegador per a preveure la instal·lació de les cookies, pero això pot dificultar l'ús de la pàgina web.",
        legal_notice: 'Avís Legal i Protecció de Dades',
        legal_notice_text_1: 
            "De conformitat amb el RGPD (UE) 2016/679 i la legislació espanyola vigent, us informem que les dades del professional usuari de la plataforma i la informació seudonimitzada del pacient introduïda en aquest programari mèdic són tractades per ADmit Therapeutics S.L. (CIF B67146738, Ctra. Laureà Miró, 408-410, 08980, Sant Feliu de Llobregat, Espanya) en qualitat d'Encarregat del Tractament per compte de l'Usuari Sol·licitant (Responsable del Tractament), d'acord amb les instruccions documentades en el contracte d'encàrrec de tractament formalitzat sota l'Article 28 del RGPD. El tractament es realitza mitjançant eines automatitzades amb l'exclusiva finalitat d'executar l'algorisme predictiu i reportar l'informe de resultats únicament a l'usuari sol·licitant a través d'aquesta plataforma protegida. A tal efecte, s'informa de la possibilitat de la transferència de les dades genètiques de seqüenciació de nova generació (NGS), de forma segura, a través de l'ecosistema en el núvol BaseSpace Sequence Hub d'Illumina; aquesta infraestructura es pot utilitzar amb l'exclusiva finalitat de canalitzar la transmissió de les dades per a la seva anàlisi automatitzada mitjançant el MAP-AD® Test, garantint rigorosament la traçabilitat i la qualitat de la informació obtinguda. La base legal que legitima el tractament per part del Responsable és el consentiment, l'execució del contracte de serveis sanitaris o el compliment d'una missió d'interès públic (Art. 6.1.a, 6.1.b o 6.1.e del RGPD), habilitat per a fins de diagnòstic mèdic (Art. 9.2.h del RGPD). Les dades i els resultats processats sota el codi d'identificació es conservaran en els sistemes durant els terminis legals de custòdia aplicables. Atesa la naturalesa estrictament seudonimitzada de les dades del pacient (la identitat real és totalment inaccessible per a ADmit Therapeutics S.L.), els interessats hauran d'exercir els seus drets d'accés, rectificació, supressió, limitació, oposició i portabilitat directament davant de l'Usuari Sol·licitant (Responsable del Tractament). Així mateix, s'informa del dret a presentar una reclamació davant l'Agència Espanyola de Protecció de Dades (AEPD).",
        confidentiality_notice: 'Avís de confidencialitat',
        confidentiality_notice_text_1: 
            "La informació visualitzada i els informes generats en aquesta plataforma contenen dades professionals i mèdiques d'alta sensibilitat i caràcter seudonimitzat, destinades exclusivament al professional sanitari autoritzat. Queda estrictament prohibit l'accés no autoritzat, la distribució, la còpia o la divulgació d'aquests continguts.",
        warnings: 'Advertències',
        warnings_text_1: 'El MAP-AD Test Software és per a ús de diagnòstic in vitro.',
        warnings_text_2:
            'Aquest programari ha de ser utilitzat únicament per professionals de la salut o personal capacitat.',
        precautions: 'Precaucions',
        precautions_text1:
            "No desconnectis l'ordinador de la presa de corrent o el cable d'Internet, ja que no podràs utilitzar el programari.",
        precautions_text2:
            'Verifica la compatibilitat del teu sistema operatiu i navegador per assegurar-te que el programari pugui funcionar. Nota: JavaScript habilitat és un requisit.',
        precautions_text3:
            "Evita l'opció de completar automàticament l'usuari i la contrasenya al navegador, ja que una altra persona podria usar el teu usuari. Nota: En cas de pèrdua o oblit de l'usuari o de la contrasenya, posa't en contacte amb ADmit Therapeutics.",
        precautions_text4:
            'Evita distraccions quan introdueixis la informació en els camps obligatoris, una dada incorrecta potencialment resultarà en un resultat incorrecte per al pacient.',
        precautions_text5:
            "Evita distraccions en registrar l'identificador de la mostra o en identificar les mostres físiques, ja que el pacient podria rebre resultats creuats.",
        precautions_text6:
            "Evita les distraccions en sol·licitar la creació de l'usuari, ja que un correu electrònic incorrecte pot provocar que no es rebin actualitzacions del pacient.",
        precautions_text7:
            'Verifica que tens disponible el IFU per a consulta. ADmit Therapeutics et pot proporcionar el IFU sota petició si es necessari.',
        precautions_text8:
            "Verifica que l'usuari i contrasenya són correctes. ADmit Therapeutics et pot proporcionar una nova contrasenya sota demanda.",
    },
    mass_upload: {
        confirm_upload: 'Vol confirmar la càrrega massiva de pacients?',
        upload_completed:
            'Carga masiva de pacients completada. Reviseu el .txt amb identificadors de pacients',
        upload_completed_file_name: 'ResultatCàrregaPacients',
    },
    error: {
        download_mass_patient_load_template: 'Error descarregant plantilla',
        validation_errors_mass_upload_txt_name: 'ErrorsValidacioCarregaPacients',
        validation_errors_mass_upload_message:
            "Errors de validació en càrrega de pacients. Revisa l'arxiu .txt descarregat",
        uploading_errors_mass_upload_txt_name: 'ErrorsCargaPacients',
        uploading_errors_mass_upload_message:
            "Errors en càrrega en pacients. Revisa l'arxiu .txt descarregat",
        password_reset_failed:
            'Error en restablir la contrasenya. Si us plau, torni-ho a provar més tard',
        password_reset_not_found_user:
            "Usuari no trobat. Si us plau, verifiqui el correu electrònic o nom d'usuari i torni-ho a provar",
    },
    reset_password: {
        password_reset_success:
            'La contrasenya s’ha restablert correctament. Comprovi el seu correu electrònic',
    },
    patient_report: {
        company_name: 'ADmit Therapeutics S.L.',
        address_line1: 'Ctra Laureà Miró, 408-410',
        address_line2: '08980 Sant Feliu de Llobregat (Barcelona), Espanya',
        phone: 'Telèfon: (34) 931 088 001',
        email: 'mapad@admit-therapeutics.com',
        patient_information: 'INFORMACIÓ DEL PACIENT',
        patient_id: 'ID del Pacient:',
        age: 'Edat:',
        cdr: 'CDR:',
        sob: 'Puntuació CDR-SOB:',
        apoe: 'Genotip APOE:',
        user_information: 'INFORMACIÓ DEL USUARI',
        user: 'Usuari:',
        account: 'Compte #:',
        test_report_title: 'Informe de Pronòstic',
        test_result: 'Resultat del Test:',
        progressed_score: 'Puntuació de Progressat:',
        non_progressed_score: 'Puntuació de No Progressat:',
        cognitively_normal_score: 'Puntuació de Cognitivament Normal:',
        category: 'Categoría:',
        interpretation: 'Interpretació:',
        interpretation_explanation:
            "La interpretació dels resultats està subjecte a l'avaluació i discreció del metge responsable",
        clinical_significance: 'Importància Clínica:',
        clinical_significance_body1:
            'El MAP-AD® Test proporciona un pronòstic de la demència per la malaltia d’Alzheimer (MA) en pacients de 55 a 85 anys avaluats per a la MA, mitjançant la mesura de metilcitosines en l’ADN total extret de sang humana i una classificació qualitativa automàtica dels subjectes com a progressats o no progressats a demència per MA.',
        clinical_significance_body2:
            'El resultat està indicat per al seu ús pels metges només com a marcador pronòstic. Aquesta prova no pretén ser una prova de cribratge o una prova diagnòstica independent.',
        methodology: 'Descripció de la Metodología:',
        methodology_body1:
            "L’ADN dels pacients és analitzat mitjançant el procés de laboratori MAP-AD® Test Oligos seguint el seu manual d’usuari. La prova es basa en la mesura de les metilcitosines en les regions d'interès de l'ADN mitocondrial de la població objectiu com a biomarcadors pronòstics de la MA. Les metilcitosines mitocondrials juntament amb les dades clíniques (edat, genotip APOE i puntuació CDR-SOB) han estat analitzades pel MAP-AD® Test Software v",
        methodology_body2: ' per obtenir els resultats.',
        legal_note: 'Avís Legal',
        legal_note_body:
            "Aquesta prova és un dispositiu de Diagnòstic In Vitro desenvolupat per ADmit Therapeutics SL sota la normativa vigent d'IVD amb finalitats clíniques.",
        pdf_version: 'Report v1.0',
        report_date_title: 'Informe emès a data:',
        page_count: 'Pàgina 1 de 1',
    },
};
